import {
  ClientBrandCode,
  RequestAction,
  RequestSource,
  TrustBox,
} from '@common';
import { BuildConfig, DomainId } from '@config';

export const buildConfig: BuildConfig = {
  applianceRegistrationLimit: 10,
  appVariantConfigPath: 'gb/sidedoor-promo',
  buildFeatures: {},
  checkout: {},
  defaultDomainId: DomainId.LG,
  domainIdMapping: {
    [DomainId.LG]: /lg\.[\w.-]*partners/,
  },
  modelNumberSearchEnabledBrands: [ClientBrandCode.LG],
  retailerFieldEnabledBrands: [],
  trustpilot: {
    businessUnitId: '4cb3113600006400050dfb02',
    templates: [
      { id: '5419b6ffb0d04a076446a9af', name: TrustBox.Micro },
      { id: '54ad5defc6454f065c28af8b', name: TrustBox.Slider },
    ],
  },
  requestAction: RequestAction.PromoOnlineRegistration,
  whiteLabelClient: RequestSource.DomesticAndGeneralUK,
};
